import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import ProductStockQuantityInfo from '../../../components/ProductStockQuantityInfo';

export interface CataloguePageListContentItemCardStockInfoProps
  extends StandardDivProps<CataloguePageListContentItemCardStockInfoClassKey> {
  // Add more prop definitions here...
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardStockInfoClassKey = 'root';

const themeSettings = { name: 'CataloguePageListContentItemCardStockInfo' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardStockInfoClassKey, {}>({
      root: {
        display: 'flex',
        // alignItems: 'center',
        justifyContent: 'flex-end',
        // paddingBottom: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: '72%',
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardStockInfo = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardStockInfoProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      <ProductStockQuantityInfo product={product} />
    </div>
  );
});

CataloguePageListContentItemCardStockInfo.displayName = 'CataloguePageListContentItemCardStockInfo';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardStockInfo);
